"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var D = __importStar(require("../../data"));
var UI = __importStar(require("../../ui"));
var Permissions = function (_a) {
    var uuid = _a.uuid, permissionInterface = _a.permissionInterface;
    return (react_1["default"].createElement(D.Load.WithLoader, { Component: function (props) { return (react_1["default"].createElement(UI.ListAssign, { data: props.data, updatePromise: function (id, assigned) {
                return permissionInterface.toggle(uuid, id, assigned);
            } })); }, dataLoad: permissionInterface.list(uuid) }));
};
exports["default"] = Permissions;
